import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';

@Component({
  selector: 'app-filter-multiselect',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <p-multiSelect
      [id]="testId"
      [styleClass]="'filter-multiselect ' + styleClass"
      [panelStyleClass]="panelClass"
      [options]="options"
      [ngModel]="value"
      (ngModelChange)="valueChange.emit($event)"
      [optionLabel]="optionLabel"
      [optionValue]="optionValue"
      [defaultLabel]="defaultLabel"
      [selectedItemsLabel]="selectedItemsLabel"
      [maxSelectedLabels]="maxSelectedLabels"
      [filter]="filter"
      [appendTo]="appendTo"
      [baseZIndex]="baseZIndex"
      (onChange)="selectionChange.emit($event)"
    ></p-multiSelect>
  `,
  styleUrls: ['./filter-multiselect.component.scss'],
})
export class FilterMultiselectComponent {
  @Input() options: any[] = [];
  @Input() value: any[] = [];
  @Input() optionLabel = 'name';
  @Input() optionValue = 'id';
  @Input() defaultLabel = 'Select Categories';
  @Input() selectedItemsLabel = '{0} selected';
  @Input() maxSelectedLabels = 2;
  @Input() filter = false;
  @Input() appendTo = 'body';
  @Input() baseZIndex = 11000;
  @Input() testId = '';
  @Input() styleClass = '';

  @Output() valueChange = new EventEmitter<any[]>();
  @Output() selectionChange = new EventEmitter<any>();

  get panelClass(): string {
    return `filter-multiselect-panel${
      this.testId ? ' ' + this.testId + '-panel' : ''
    }`;
  }
}
